import * as t from 'ts-schema';
import { NavItemId } from 'nav-meta/models/nav-item-id.model';
import { NavStructureId } from 'nav-meta/models/nav-structure-id.model';
export const navItemIdSchema = t.custom('NavItemId', value => typeof value === 'string' && NavItemId.is(value));
export const navStructureIdSchema = t.custom('NavStructureId', value => typeof value === 'string' && NavStructureId.is(value));
const navStructureNavItemSchema = t.object({
  id: navStructureIdSchema,
  type: t.literal('ITEM'),
  kind: t.literal('NAV_ITEM'),
  navItemId: navItemIdSchema
});
const navStructureDividerSchema = t.object({
  id: navStructureIdSchema,
  type: t.literal('ITEM'),
  kind: t.literal('DIVIDER')
});
export const navStructureItemSchema = t.recursive(self => {
  const children = t.array(self);
  return t.union(navStructureNavItemSchema, navStructureDividerSchema, t.object({
    id: navStructureIdSchema,
    type: t.literal('GROUP'),
    kind: t.union(t.literal('PINNED_ITEMS'), t.literal('EXPANDABLE')),
    children
  }), t.object({
    id: navStructureIdSchema,
    type: t.literal('GROUP'),
    kind: t.literal('LABELED'),
    children,
    label: t.string
  }), t.object({
    id: navStructureIdSchema,
    type: t.literal('GROUP'),
    kind: t.union(t.literal('LABELED_WITH_ICON'), t.literal('DISCOVER_MORE'), t.literal('BOOKMARKS')),
    children,
    label: t.string,
    icon: t.string
  }));
});
export const navStructureSurfaceSchema = t.object({
  items: t.array(navStructureItemSchema)
});